import { ChurchUnit } from './church-unit.model';

export class SortableChurchUnit extends ChurchUnit {
    sortName: string;
    sortNumber: number
}
